/** Camera-relative movement basis, independent of the render rig. */
export interface MoveBasis {
  forwardX: number;
  forwardZ: number;
  rightX: number;
  rightZ: number;
}

/** Camera-relative movement basis for WASD. XZ only, y stripped, normalised. */
export function moveBasisFromYaw(yaw: number, out: MoveBasis): void {
  // Derived from the rig's YAW, not from where the lens happens to point.
  //
  // Those differ by the over-the-shoulder offset: the camera sits 0.22 m to
  // one side and looks AT her, so its world direction is ~7 degrees off the
  // yaw. Feeding that back as the movement basis creates a loop — she turns
  // to the offset heading, the idle auto-yaw follows her, the offset applies
  // again — and she curves steadily away instead of walking straight. Holding
  // W drifted her about 30 degrees off course over five metres, which read as
  // a wonky controller and was really the camera talking to itself.
  //
  // The yaw is the player's intent. The shoulder is framing. Only one of them
  // belongs in a movement basis.
  out.forwardX = Math.sin(yaw);
  out.forwardZ = Math.cos(yaw);
  // right = forward × up. Three is right-handed with Y up, so this is
  // (-forwardZ, forwardX) and NOT its negation — which is what shipped first
  // and made D strafe her to screen-left.
  out.rightX = -out.forwardZ;
  out.rightZ = out.forwardX;
}
